import { FormControl, Icon, InputAdornment } from '@material-ui/core';
import { TimePicker, TimePickerProps } from '@material-ui/pickers';
import { Field, FieldProps } from 'formik';
import { Moment } from 'moment';
import React from 'react';

interface ITimeFormFieldProps extends Omit<TimePickerProps, 'name' | 'value' | 'error' | 'variant' | 'onChange'> {
    name : string;
}

interface ITimeFormFieldState {}

export default class TimeFormField extends React.PureComponent<ITimeFormFieldProps, ITimeFormFieldState> {
    constructor(props : ITimeFormFieldProps) {
        super(props);
        this.state = {};
    }
    

    public readonly render = () => {
        const { id, name, ...rest } = this.props;
        return (
            <Field
                id={id}
                name={name}
            >
                {
                    (params : FieldProps<Moment>) => (
                        <FormControl fullWidth={rest.fullWidth} required={rest.required}>
                            <TimePicker
                                {...rest}
                                {...params.field}
                                onChange={(date) => params.form.setFieldValue(params.field.name, date)}
                                value={params.field.value}
                                error={!!params.meta.error}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position='end'>
                                            <Icon>access_time</Icon>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </FormControl>
                    )
                }
            </Field>
        );
    };
}
